<ng-container [formGroup]="formGroup">
  <input type="hidden" [formControl]="control | getAsFormControl" [attr.placeholder]="showPlaceholder ? (placeholder + '&#8230;') : null">
</ng-container>
